module.exports = __webpack_public_path__ + "media/images/icons/marker-50a82a1ce312948d298b8ea9a003bf0f.png";